module.exports = __webpack_public_path__ + "img/wyfwx.c205ec3f.jpg";